import { get } from '@/utils/lodash'

export function getGlobalConfig (configKey, defaultValue = undefined) {
  try {
    // noinspection JSUnresolvedVariable
    if (window && window.__EP_SETTINGS__) {
      return get(window.__EP_SETTINGS__, configKey)
    }

    const configName = process.env.VUE_APP_CONFIG_NAME || 'config.default.js'
    // NOTE: below is a hack to bypass webpack alias resolving
    const { config } = require('@/config/' + configName.replace(/\.js/, '') + '.js')
    return get(config, configKey, defaultValue)
  } catch (error) {
    console.error('Error while getting global configuration', error)
    return defaultValue
  }
}
